module.exports = __webpack_public_path__ + "static/media/books.23cab92e.jpg";